@if (isLoading()) {
  <mat-progress-bar mode="query"></mat-progress-bar>
}

@if (departments$ | async; as departmentsList) {
  @if (form) {
    <h5 mat-dialog-title class="modal-dialog m-0">
      Select Department
      <dialog-close-button (click)="setCloseConfirmation()" [closeWithoutConfirm]="false"></dialog-close-button>
    </h5>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" data-testId="select-departments-form">
      <mat-dialog-content>
        <!-- All Departments Checkbox -->
        <div class="ps-3 mb-3">
          <mat-checkbox color="primary" formControlName="selectAll" data-testId="all-departments-checkbox">
            <span class="ms-2">All departments</span>
          </mat-checkbox>
        </div>
        <p class="accessible-department mb-2">Accessible departments</p>

        <!-- Search Box -->
        <div class="row-cols-1">
          <mat-form-field data-testId="search-box" class="mat-form-no-field-wrapper">
            <input matInput placeholder="Search departments" autocomplete="off" [formControl]="formFilter" />
            <button mat-icon-button matSuffix type="button">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <!-- Department List -->
        <div class="departments-list" formGroupName="departments">
          <div class="departments-grid">
            @for (department of departmentsList; track department) {
              <div class="ps-3 department-checkbox">
                <mat-checkbox
                  color="primary"
                  [formControlName]="department.id.toString()"
                  (change)="form.markAsDirty()"
                  data-testId="department-checkbox"
                >
                  <span
                    class="ms-2 text-ellipsis d-block"
                    [matTooltip]="department.name"
                    matTooltipPosition="above"
                    matTooltipClass="custom-tooltip"
                    [appIsOverflowField]="true"
                  >
                    {{ department.name }}
                  </span>
                </mat-checkbox>
              </div>
            }
          </div>

          <!-- No results message -->
          @if (departmentsList.length === 0) {
            <div class="flex-content-center pt-3">No departments found</div>
          }
        </div>
      </mat-dialog-content>

      <mat-dialog-actions class="p-4">
        <button
          mat-button
          color="primary"
          type="button"
          data-testId="select-department-cancel-button"
          class="action-button"
          (click)="setCloseConfirmation()"
        >
          Cancel
        </button>
        <button
          mat-flat-button
          color="primary"
          type="submit"
          data-testId="select-department-submit-button"
          class="action-button-primary"
          cdkFocusInitial
          [disabled]="!canSubmitForm()"
        >
          Select Department
        </button>
      </mat-dialog-actions>
    </form>
  }
}
